import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import InlineTable from "../../components/InlineTable";
import {Query} from "react-apollo";
import gql from "graphql-tag";

const FIELDS = fromJS([
  { field: "quantity", title: "Qty." },
  { field: "productSku", title: "Product" },
  { field: "productTitle", title: "Title"}
])

const STOCK_FIELDS = fromJS([
  { field: "quantity", title: "Qty." },
  { field: "productSku", title: "Reserved Stock" },
])

const DeliveryInfoPanel = (props) => {

  let elements = null;
  if (!props.deliveryId || props.deliveryId === "") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "deliveryId", label: "Id", type: "id"},
      {prop: "accountId", label: "Account", type: "accountId"},
      {prop: "subscriptionId", label: "Subscription", type: "subscriptionId"},
      {prop: "salesOrderId", label: "Sales Id", type: "salesOrderId"},
      {prop: "shippingOrderId", label: "Shipping Id", type: "shippingOrderId"},
      {prop: "shopId", label: "Shop", type: "id"},
      {prop: "seqId", label: "Delivery Seq Nr", type: "id"},
      {prop: "warehouseId", label: "Warehouse", type: "id"},
      {prop: "stockStatus", label: "Stock Status", type: "string"},
      {prop: "scheduleStatus", label: "Schedule Status", type: "string"},
      {prop: "requestStatus", label: "Request Status", type: "string"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "requestedDeliveryDate", label: "Req. Delivery", type: "string"},
      {prop: "prepDate", label: "Prep Date", type: "string"},
      {prop: "pickupDate", label: "Pickup Date", type: "string"},
      {prop: "deliveryDate", label: "Delivery Date", type: "string"},
      {prop: "shippingAddress", label: "Address", type: "shippingAddress"}
    ])
    let variables = {deliveryId: props.deliveryId}
    elements = (
      <Query query={DELIVERY_INFO} variables={variables} skip={props.deliveryId === ""} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let imData = fromJS(data.subscriptionDelivery)
          return (
            <React.Fragment>
              <PropertiesList properties={properties} data={imData} />
              <br/>
              <InlineTable
                data={imData.get("products")}
                fields={FIELDS}
                dataType="delivery_product"
                />              
              <br/>
              <InlineTable
                data={imData.get("stock")}
                fields={STOCK_FIELDS}
                dataType="stock_product"
                />              
            </React.Fragment>
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Delivery Info" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

const DELIVERY_INFO = gql`
  query subscriptionDelivery($deliveryId:ID!) {
    subscriptionDelivery(deliveryId: $deliveryId) {
      deliveryId
      salesOrderId
      accountId
      subscriptionId
      warehouseId
      shippingOrderId
      shopId
      seqId
      stockStatus
      scheduleStatus
      requestStatus
      status
      requestedDeliveryDate
      prepDate
      pickupDate
      deliveryDate
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
        addressCountryName
      }
      products {
        productSku
        productTitle
        quantity
      }
      stock {
        productSku
        quantity
      }
    }
  }  
`;

export default DeliveryInfoPanel;